import { render, staticRenderFns } from "./index.vue?vue&type=template&id=0f5dd40c&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f5dd40c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\XM\\QD\\yangzhou\\merchant-admin\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0f5dd40c')) {
      api.createRecord('0f5dd40c', component.options)
    } else {
      api.reload('0f5dd40c', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=0f5dd40c&scoped=true", function () {
      api.rerender('0f5dd40c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/scenic-spot/label/index.vue"
export default component.exports